import { render } from "./LiquorLicenseModal.vue?vue&type=template&id=bcad48a2"
import script from "./LiquorLicenseModal.vue?vue&type=script&lang=js"
export * from "./LiquorLicenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__